var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "numeration" },
    [
      _c(_setup.NumerationTitleComponent),
      _setup.gridConfiguration
        ? _c(_setup.LfGridComponent, {
            attrs: {
              gridConfiguration: _setup.gridConfiguration,
              itemData: _setup.numerationList,
              toolbarOptions: _setup.toolbarItemsOptions,
              contextMenuItems: _setup.contextMenuItems,
              commandClick: _setup.onCommandClick,
              exportName: _setup.texts.title,
            },
            on: {
              toolbarClicked: _setup.onToolbarClick,
              contextMenuClicked: _setup.onContextMenuClicked,
              rowClick: _setup.onRowClick,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }